import MainScreen from './MainScreen';

export default MainScreen;